<template>
	<div class="offer-verified__divider" />
</template>

<style lang="scss" scoped>
.offer-verified__divider {
	flex-shrink: 0;
	width: 100%;
	height: 0.1rem;
	background-color: $color-primary-l4;

	@include media-query-up($breakpoint-small) {
		width: 0.1rem;
		min-height: 100%;
		height: auto;
	}
}
</style>
